import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=000704b0&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=000704b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000704b0",
  null
  
)

export default component.exports